import { TransactionDetails } from '@/features/payments/payments.models'

import { createApiInstance } from '@/infrastructure/apis/apiInstance'

export async function callFetchPaymentTransactionDetails({ transactionId }: { transactionId: string }) {
  const response = await createApiInstance().get(`/PaymentTransactions/${transactionId}`)
  return response.data as TransactionDetails
}
